import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { prefersDark } from '../../internal/preferences.js';
import { isNight } from '../../internal/theme.js';
import { watch } from '../../internal/watch.js';
import { CONTAINER_THEMES } from './constants/ContainerConstants.js';
import { ICON_TYPES } from '../icon/constants/IconConstants.js';
import styles from './arc-container.styles.js';
import '../accessibility/arc-accessibility.js';
import '../bottombar/arc-bottombar.js';
import '../icon-button/arc-icon-button.js';
export default class ArcContainer extends LitElement {
    constructor() {
        super(...arguments);
        this.theme = CONTAINER_THEMES.auto;
        this.fullscreen = false;
    }
    handleThemeChange() {
        if (CONTAINER_THEMES[this.theme] === CONTAINER_THEMES.auto || !(this.theme in CONTAINER_THEMES)) {
            this.theme = this.getTheme();
        }
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.theme in CONTAINER_THEMES) {
            this._appPreferredTheme = this.theme;
        }
    }
    getTheme(date) {
        return isNight(date) || prefersDark() ? CONTAINER_THEMES.dark : CONTAINER_THEMES.light;
    }
    handleAccessibilityChange(event) {
        const { preferences } = event.detail;
        const { theme } = preferences;
        if (!!theme && theme in CONTAINER_THEMES) {
            this.theme = theme;
            return;
        }
        this.theme = this._appPreferredTheme;
    }
    showAccessibility() {
        this.accessibility.open = true;
    }
    render() {
        return html `
      <div id="main">
        <slot id="nav" name="nav" @arc-show-accessibility=${this.showAccessibility}></slot>
        <div
          id="container"
          class=${classMap({
            container: true,
            'container--fullscreen': this.fullscreen,
        })}
        >
          <slot name="side"></slot>
          <div id="content">
            <slot></slot>
          </div>
        </div>
        <arc-accessibility
          id="accessibility"
          @arc-accessibility-change=${this.handleAccessibilityChange}
        ></arc-accessibility>
        <slot name="bottom">
          <arc-bottombar>
            <arc-icon-button name=${ICON_TYPES.home} href="/" label="Return home">Home</arc-icon-button>
            <arc-icon-button
              name=${ICON_TYPES.accessibility}
              label="Accessibility panel"
              @click=${this.showAccessibility}
              >Accessibility
            </arc-icon-button>
          </arc-bottombar>
        </slot>
      </div>
    `;
    }
}
ArcContainer.tag = 'arc-container';
ArcContainer.styles = styles;
__decorate([
    query('#main')
], ArcContainer.prototype, "container", void 0);
__decorate([
    query('#accessibility')
], ArcContainer.prototype, "accessibility", void 0);
__decorate([
    property({ type: String, reflect: true })
], ArcContainer.prototype, "theme", void 0);
__decorate([
    property({ type: Boolean })
], ArcContainer.prototype, "fullscreen", void 0);
__decorate([
    watch('theme')
], ArcContainer.prototype, "handleThemeChange", null);
